var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("NcDialog", {
    attrs: {
      "dialog-classes": "bbb-send-file-dialog",
      size: "normal",
      visible: _vm.opened,
      name: _vm.title
    },
    on: {
      closing: _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c("button", {
          staticClass: "nc-btn nc-btn--tertiary",
          on: {
            click: _vm.onClose
          }
        }, [_vm._v("\n\t\t\t" + _vm._s(_vm.t("bbb", "Close")) + "\n\t\t")])];
      },
      proxy: true
    }])
  }, [_vm.loading ? _c("NcLoadingIcon", {
    attrs: {
      size: 32,
      name: _vm.t("bbb", "Loading…"),
      appearance: "dark"
    }
  }) : _c("div", {
    staticClass: "send-file__content"
  }, [_vm._t("body", function () {
    return [_c("p", [_vm._v("\n\t\t\t\t" + _vm._s(_vm.t("bbb", 'Please select the room in which you like to use the file "{filename}".', {
      filename: _vm.filename
    })) + "\n\t\t\t")]), _vm._v(" "), _c("p", {
      staticClass: "note"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.t("bbb", "Only rooms for which you are one of the administrators will be displayed.")) + "\n\t\t\t")]), _vm._v(" "), _c("div", {
      staticClass: "send-file__content__container"
    }, [_vm.rooms.length > 0 ? _c("table", {
      staticClass: "send-file__content__table"
    }, _vm._l(_vm.rooms, function (room) {
      return _c("tr", {
        key: room.id
      }, [_c("td", [_c("NcButton", {
        attrs: {
          variant: room.running ? "success" : "primary"
        },
        on: {
          click: function ($event) {
            return _vm.sendFileToRoom(room.uid);
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(room.running ? _vm.t("bbb", "Send to") : _vm.t("bbb", "Start with")) + "\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c("td", [_vm._v(_vm._s(room.name))])]);
    }), 0) : _c("p", [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.t("bbb", "No rooms available!")) + "\n\t\t\t\t")])])];
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };